<i18n src="./resources/locales.json" />

<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <v-card color="surface lighten-1">
      <v-card-title v-show="title" class="header">
        {{ title }}
      </v-card-title>

      <!-- eslint-disable-next-line vue/no-v-html -->
      <v-card-text class="pt-2 pb-6 px-6" v-html="message"></v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel()">
          {{ cancelButtonText }}
        </v-btn>
        <v-btn color="primary" depressed :loading="isLoading" @click="accept()">
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EcsConfirmationDialog',

  data() {
    return {
      title: '',
      message: '',
      confirmButtonText: '',
      cancelButtonText: '',
      dialog: false,
      isLoading: false
    };
  },

  mounted() {
    this.$root.$on('open-confirm-dialog', this.open);
  },

  beforeDestroy() {
    this.$root.$off('open-confirm-dialog');
  },

  methods: {
    open({ title, message, action, confirmButtonText, cancelButtonText }) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.confirmButtonText = confirmButtonText || this.$t('buttons.confirm');
      this.cancelButtonText = cancelButtonText || this.$t('buttons.cancel');
      this.$once('confirm', confirm => {
        this.isLoading = true;
        action(confirm)
          .then(() => (this.dialog = false))
          .finally(() => (this.isLoading = false));
      });
    },
    accept() {
      this.$emit('confirm', true);
    },
    cancel() {
      this.$emit('confirm', false);
    }
  }
};
</script>
